import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {EntityKey} from '../entity/entity';
import {EntityComplexity} from '../model/entity-complexity';

@Service()
export class EntityComplexityService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  getEntityComplexity(key: EntityKey): Observable<EntityComplexity> {
    const url = this.urlBase + 'entityComplexity/' + key.entityId + '/' + key.entityRevision;
    return this.http.get<EntityComplexity>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  updateEntityComplexity(key: EntityKey): Observable<EntityComplexity> {
    const url = this.urlBase + 'entityComplexity/update/' + key.entityId + '/' + key.entityRevision;
    return this.http.get<EntityComplexity>(url, {headers: this.getRequestHeaders()});
  }

}
